/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import { Header, SideMenu, Search, Button } from 'components';
import { Container, ContentArea, Title, Div, DataArea, LoadingArea, CountArea, ButtonTable } from './styles';
import { loadingColor, primary } from 'styles/colorProvider';
import { BiPencil, BiTrash } from 'react-icons/bi';
import moment from 'moment';
import { formatCurrency } from 'react-data-formatter';
import { RenderAddProductSva, RenderEditProductSva, renderRemoveProductSva } from './modals';
import { loadData } from './requests';

function BackOfficeProductsSva({ history }) {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [search, setSearch] = useState();
  const [products, setProducts] = useState([]);
  const [editId, setEditId] = useState(null);
  const [removeId, setRemoveId] = useState(null);
  const [itemData, setItemData] = useState({ name: '', value: '', charge_type: '' });

  const [openModalAdd, setOpenModalAdd] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openModalRemove, setOpenModalRemove] = useState(false);
  const [touchFilter, setTouchFilter] = useState();

  const resetValues = () => setItemData({ name: '', value: '', charge_type: '' });

  const handleLoadData = () => {
    loadData({
      setData: setProducts,
      setLoading,
      setTouchFilter,
      search,
    });
  };

  useEffect(() => {
    handleLoadData();
  }, []);

  const handleType = (type) => {
    const types = [
      {
        label: 'unique',
        value: 'Único',
      },
      {
        label: 'periodic',
        value: 'Recorrente',
      },
    ];

    return types.find((item) => item.label === type)?.value;
  };

  const handleValueType = (type) => {
    const types = [
      {
        label: 'value',
        value: 'Valor fixo',
      },
      {
        label: 'percentage',
        value: 'Porcentagem',
      },
    ];

    return types.find((item) => item.label === type)?.value;
  };

  const dataColumns = [
    {
      name: 'ID',
      selector: (row) => row?.id,
      width: '5%',
      sortable: true,
    },
    {
      name: 'Nome',
      selector: (row) => row?.name,
      width: '15%',
      sortable: true,
    },
    {
      name: 'Tipo',
      selector: (row) => handleType(row?.charge_type),
      width: '8%',
      sortable: true,
    },
    {
      name: 'Valor',
      selector: (row) => (row.value_type === 'value' ? formatCurrency(row?.value) : `${row?.value}%`),
      width: '8%',
      sortable: true,
    },
    {
      name: 'Tipo do valor',
      selector: (row) => handleValueType(row?.value_type),
      width: '10%',
      sortable: true,
    },
    {
      name: 'Todas as vendas',
      selector: (row) => (row?.applied_automatic ? 'Sim' : 'Não'),
      width: '10%',
      sortable: true,
    },
    {
      name: 'Criado em',
      selector: (row) => moment(row.created_at).format('DD/MM/YYYY'),
      width: '12%',
      sortable: true,
    },
    {
      name: 'Última atualização',
      selector: (row) => moment(row.updated_at).format('DD/MM/YYYY'),
      width: '12%',
      sortable: true,
    },
    {
      name: 'Editar',
      selector: (row) => (
        <ButtonTable
          onClick={() => {
            setEditId(row.id);
            setItemData({
              name: row.name,
              value: row.value,
              charge_type: row.charge_type,
              value_type: row.value_type,
              applied_automatic: row.applied_automatic,
            });
            setOpenModalEdit(true);
          }}
        >
          <BiPencil size={16} />
        </ButtonTable>
      ),
      width: '7%',
      sortable: false,
    },
    {
      name: 'Excluir',
      selector: (row) => (
        <ButtonTable
          onClick={() => {
            setRemoveId(row.id);
            setOpenModalRemove(true);
          }}
        >
          <BiTrash size={16} />
        </ButtonTable>
      ),
      width: '7%',
      sortable: false,
    },
  ];

  return (
    <>
      <Header />
      <Container>
        {RenderAddProductSva({
          loadData: handleLoadData,
          openModalAdd,
          setOpenModalAdd,
          setLoading,
          loading,
          loadingData,
          setLoadingData,
        })}

        {RenderEditProductSva({
          id: editId,
          data: itemData,
          setData: setItemData,
          openModalEdit,
          setOpenModalEdit,
          setLoading,
          loading,
          loadData: handleLoadData,
          loadingData,
          setLoadingData,
          resetValues,
        })}

        {renderRemoveProductSva({
          id: removeId,
          loadData: handleLoadData,
          openModalRemove,
          setOpenModalRemove,
          setLoading,
          loading,
          loadingData,
          setLoadingData,
        })}

        <SideMenu />
        <ContentArea>
          <Div>
            <Title>Produtos SVA</Title>
            <div className="containerTitle">
              <Button title="Adicionar" height="30px" onClick={() => setOpenModalAdd(true)} disabled={loading}>
                Adicionar
              </Button>

              <Search
                value={search}
                placeholder={'Buscar por produto'}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  handleLoadData();
                }}
                onConfirm={handleLoadData}
              />
            </div>
          </Div>
          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={() => {}}
              useWindow={false}
              getScrollParent={() => scrollParent?.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={0}
            >
              <DataTable
                persistTableHead
                responsive
                columns={dataColumns}
                data={products}
                highlightOnHover
                pointerOnHover
                fixedHeader
                fixedHeaderScrollHeight="100%"
                progressPending={loading}
                progressComponent={
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                }
                noDataComponent={<small style={{ marginTop: 20 }}>Nenhuma informação encontrada</small>}
              />
            </InfiniteScroll>
          </DataArea>
          <CountArea>{!loading && <p style={{ color: primary }}>Mostrando {products?.length} produtos</p>}</CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default BackOfficeProductsSva;
